import { c as _c } from "react/compiler-runtime";
import CreditSuccess from "@assets/illustrations/credits/credit-success.svg?react";
import { Text, Dialog, SvgIcon } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { CREDITS_DISPLAY_NAME, HAS_CREDIT_PURCHASED } from "@src/constants/credit-constants";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { useState } from "react";

/** Renders credit purchase success dialog */
export function CreditPurchaseSuccess() {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = localStorage.getItem(HAS_CREDIT_PURCHASED);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const hasCreditPurchased = t0;
  const [shouldShowDialog, setShouldShowDialog] = useState(hasCreditPurchased === "true");
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function dialogConfirmCallback() {
      localStorage.removeItem(HAS_CREDIT_PURCHASED);
      setShouldShowDialog(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const dialogConfirmCallback = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SvgIcon source={CreditSuccess} sx={{
      width: "100%",
      height: "100%",
      fill: "none"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center",
      gap: 1.5
    };
    t4 = <Text variant="heading24">Thanks for your purchase!</Text>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = capitalizeFirstLetter(CREDITS_DISPLAY_NAME);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Stack sx={t3}>{t4}<Text variant="bodyM" textAlign="center">{t5} will be added soon (usually within 2 hours). <br />Contact support if there is more delay.</Text></Stack>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== shouldShowDialog) {
    t7 = <Dialog open={shouldShowDialog} onConfirm={dialogConfirmCallback} confirmText="Got it" title="">{t2}{t6}</Dialog>;
    $[7] = shouldShowDialog;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}